import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Card, Grid, Typography } from "@material-ui/core";

import { useTraslados } from "../../../hooks/useCases/useTraslados";
import { SelectValidatorGeneric } from "../../atomic/atoms/Select";
import { required } from "../../../helpers/validations/validators";
import { Buscador } from "../../atomic/molecules/Buscador";
import { ButtonGeneric } from "../../atomic/atoms/Buttons";
import LetterX from "../../autorizaciones/UI/LetterX";
import AlertCircle from "../../autorizaciones/UI/AlertCircle";
import CheckCircle from "../../autorizaciones/UI/CheckCircle";
import { GAccordion } from "../../atomic/organisms/GAccordion";
import { GenericTable } from "../../atomic/organisms/GenericTable";
import { GCheckbox } from "../../atomic/atoms/GCheckbox";


export const DatosSolicitudTraslado = ({formValues, handleInputChange, setFormValues, disabled}) => {
    const componentRef = useRef();
    const { data, get } = useTraslados();

    const { items: localidades } = useSelector((state) => state.localidades);
    const { items: provincias } = useSelector((state) => state.provincias);

    const [practica, setPractica] = useState(null);
    const [efectores, setEfectores] = useState([]);
    // const [medicos, setMedicos] = useState([]);

    return (
        <Grid container style={{padding: "1em"}}>
            {[
                <SelectValidatorGeneric
                    label="Tipo Solicitud"
                    name="idTipoSolicitud"
                    value={formValues.idTipoSolicitud}
                    onChange={handleInputChange}
                    menuItems={data.dim.tipoSolicitudes.map(item => ({
                        value: item.id,
                        label: item.descripcion
                    }))}
                    disabled
                    validations={[required]}
                />,
                <Grid container component={Card} style={{padding: "1em"}}>
                    <Grid item xs={12} align="center">
                        <Typography variant="h6" style={{marginBottom: "0.5em"}}>
                            PRÁCTICA
                        </Typography>
                    </Grid>
                    {formValues.practica ? (
                        <Grid item xs={12} style={{marginTop: "1em", display: "flex", justifyContent: "flex-start", alignItems: "center"}}>
                            {!disabled && (
                                <LetterX
                                    deleteFunction={() => {
                                        setEfectores([]);
                                        // setMedicos([]);
                                        setFormValues({
                                            ...formValues,
                                            idPractica: "",
                                            practica: null,
                                            idEfectorFacturacion: "",
                                            efector: null
                                        });
                                    }}
                                    styles={{
                                        cursor: "pointer",
                                        marginRight: "0.5rem",
                                    }}
                                />
                            )}
                            <Typography variant="h6" style={{fontStyle: "italic", fontSize: "1em"}}>
                                {`${formValues.practica?.codNom} - ${formValues.practica?.desNom}`}
                            </Typography>
                        </Grid>
                    ) : (
                        <Grid item xs={12} style={{textAlign: "center", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "1em"}}>
                            <Buscador 
                                ref={componentRef}
                                value={practica}
                                variant="outlined"
                                setValue={(val) => setPractica(val)}
                                label="Práctica Nomenclador"
                                endpoint={(inputValue) => `NomencladorNacional?codigoNombre=${inputValue}&todas=${true}`}
                                noOptionText={"No hay practicas"}
                                getOptionLabel={(option) => `${option.codNom}-${option.desNom}`}
                                autoComplete
                                includeInputInList
                                filterSelectedOptions
                                disabled={formValues.practica !== null}
                            />
                            <ButtonGeneric 
                                text="Agregar"
                                disabled={formValues.practica !== null || practica === null}
                                onClick={() => {
                                    setPractica(null);
                                    setFormValues({
                                        ...formValues,
                                        idPractica: practica.id,
                                        practica: practica
                                    });
                                }}
                            />
                        </Grid>
                    )}
                </Grid>,
                <GAccordion 
                    title={(
                        <Typography variant="h6">
                            Efector
                            {!formValues.efector 
                                ? <AlertCircle /> 
                                : <CheckCircle />
                            }
                        </Typography>
                    )}
                >
                    <AccordionSelection 
                        data={efectores}
                        get={() => get.contratos.efectores(formValues.practica.codNom, setEfectores)}
                        disabledGet={formValues.practica === null}
                        condition={!formValues.efector}
                        letter={`${formValues.efector?.razonSocial} - ${formValues.efector?.cuit}`}
                        // disabledLetter={disabled}
                        remove={() => {
                            // setMedicos([]);
                            setFormValues({
                                ...formValues,
                                efector: null,
                                idEfectorFacturacion: ""
                            });
                        }} 
                        columns={[
                            {
                                label: "",
                                customBody: (efector) => (
                                    <GCheckbox 
                                        value={false}
                                        onChange={() => {
                                            setFormValues({
                                                ...formValues,
                                                efector,
                                                idEfectorFacturacion: efector.idEfectorFacturacion
                                            })
                                        }}
                                    />
                                )
                            },
                            {
                                label: 'Nombre del Efector',
                                id: 'razonSocial',
                            },
                            {
                                label: 'CUIT',
                                id: "cuit"
                            },
                            {
                                label: 'Domicilio',
                                customBody: (item) => item.efectorDomicilio 
                                    ? `${item.efectorDomicilio?.calle} ${item.efectorDomicilio?.nro} - ${provincias.find(({id_provincia}) => id_provincia === item.efectorDomicilio.idProvincia)?.descripcion_provincia} - ${localidades.find(({id_localidad}) => id_localidad === item.efectorDomicilio?.idLocalidad)?.descripcion_localidad}` 
                                    : "No informado"
                            },
                        ]}
                    />
                </GAccordion>,
                // <GAccordion 
                //     title={(
                //         <Typography variant="h6">
                //             Médico Tratante
                //             {!formValues.medico 
                //                 ? <AlertCircle /> 
                //                 : <CheckCircle />
                //             }
                //         </Typography>
                //     )}
                // >
                    
                //     <AccordionSelection 
                //         data={medicos}
                //         get={() => get.contratos.prestadores(formValues.idEfectorFacturacion, setMedicos)}
                //         disabledGet={formValues.efector === null}
                //         condition={!formValues.medico}
                //         letter={`${formValues.medico?.nombreApellido || formValues.medico?.apellidoNombre}`}
                //         disabledLetter={disabled}
                //         remove={() => {
                //             setFormValues({
                //                 ...formValues,
                //                 medico: null,
                //                 idMedico: ""
                //             });
                //         }} 
                //         columns={[
                //             {
                //                 label: "",
                //                 customBody: (medico) => (
                //                     <GCheckbox 
                //                         value={false}
                //                         onChange={() => {
                //                             setFormValues({
                //                                 ...formValues,
                //                                 medico,
                //                                 idMedico: medico.id
                //                             })
                //                         }}
                //                     />
                //                 )
                //             },
                //             {
                //                 label: 'Nombre',
                //                 id: 'apellidoNombre',
                //             },
                //             {
                //                 label: 'Maricula Nacional',
                //                 customBody: ({matriculaNac}) => matriculaNac || "No posee"
                //             },
                //             {
                //                 label: 'Matricula Provincial',
                //                 customBody: ({matriculaProv}) => matriculaProv || "No posee"
                //             },
                //         ]}
                //     />
                // </GAccordion>
            ].map((Component, index) => (
                <Grid key={index} item xs={12} style={index !== 0 ?  {marginTop: "0.5em"} : {}}>
                    {Component}
                </Grid>
            ))}
        </Grid>
    );
};

export const AccordionSelection = ({data, columns, remove, condition, letter, get, disabledGet, disabledLetter}) => {
    const componentRef = useRef()
    return (
        <Grid item xs={12}>
            {condition ? (
                <Grid container>
                    <Grid item xs={12} style={{textAlign: "center", marginBottom: "0.5em"}}>
                        <ButtonGeneric 
                            text="Consultar"
                            disabled={disabledGet}
                            onClick={get}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <GenericTable
                            ref={componentRef}
                            data={data}
                            withoutPagination
                            align="center"
                            columns={columns}
                        />
                    </Grid>
                </Grid>
            ) : (
                <Typography
                    style={{
                    color: "#68389F",
                    width: "-webkit-fill-available",
                    fontSize: "1rem",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    postion: "relative",
                    }}
                >
                    {letter}
                    {!disabledLetter && (
                        <LetterX 
                            deleteFunction={remove} 
                            styles={{ position: "absolute", marginLeft: "0.5rem", cursor: "pointer" }}
                        />
                    )}
                </Typography>
            )}
        </Grid>
    )
}
